<template>
	<div>
		<div class="" @click="onClickButton">
			<div class="vod-item my-2 p-3" v-if="stream.totalFiles > 0">
				<img class="vod-item__icon" width="32" height="21" src="@/assets/images/Folder.svg" alt="Folder">
				<h3 class="vod-item__title">
					{{ shortString(stream.name, 25) }}
				</h3>
				<div class="vod-item__files">
					{{ stream.totalFiles }} files
				</div>
				<div class="vod-item__size">
					{{ getBytes }}	
				</div>
				<div class="vod-item__date">
						{{ date(stream.creationTime, 'hh:mm DD-MM-YYYY') }}
				</div>
			</div>
			<div class="vod-item my-1 py-2 px-4 items-center" v-if="stream.fileName">
				<FormCheckbox :name="'vod-card-' + stream.id" :input-value="stream.id" v-model="isChosen" />
				<div class="vod-item__info">
					<h3 class="vod-item__title vod-item__title_files">
						{{ shortString(stream.fileName, 25) }}
					</h3>
					<span v-if="hasResolution" class="vod-item__res">{{stream.mediaInfo.width}}x{{stream.mediaInfo.height}}</span>
					<span v-if="hasResolution && stream.mediaInfo.duration" class="mx-2">•</span>
					<span class="vod-item__res">
						<span v-if="stream.mediaInfo?.duration<60">
							{{ stream.mediaInfo.duration }}
							<small>SECS</small>
						</span>
						<span v-else-if="stream.mediaInfo?.duration">
							{{ numberFormat(stream.mediaInfo.duration/60) }}
							<small>MINS</small>
						</span>
					</span>
				</div>
				<ul class="vod-item__presets">
					<li class="vod-item__preset-item" :key="preset.id" v-for="preset in stream.encodingPresets">{{preset}}</li>
				</ul>
				<div class="vod-item__size">{{ showFileSize }}</div>
				<div class="vod-item__date">
					{{ date(stream.creationTime, 'hh:mm DD-MM-YYYY') }}
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
import StreamThumb from '@/components/ui/StreamThumb.vue';
import FormCheckbox from '@/components/Atoms/FormCheckbox.vue';
// import StreamPlayerHls from "@/components/ui/StreamPlayer.hls.vue";
import StreamService from '@/services/StreamService';
import StreamStatsService from '@/services/StreamStatsService';
import { shortString, date, numberFormat } from '@/filtersNew';

export default {
	name: 'VODCardView',
	components: {
		StreamThumb,
		FormCheckbox
		// StreamPlayerHls
	},
	props: {
		stream: {
			type: Object,
			required: true,
		},
		compactMode: {
			required: true
		}
	},
	data() {
		return {
			VODList: [],
			scopeAlive: true,
			randId: Math.random()
				.toString()
				.slice(2),
			statusProcessing: false,
			isChosen: false,
			streamStatus: this.stream.enabled,
			mediaPulse: null,
			mediaPulseTimeoutCtrl: null
		};
	},
	computed: {
		streamAlive() {
			return this.streamStatus && this.mediaPulse && this.mediaPulse.alive;
		},
		hasResolution() {
			const mediaInfo = this.stream.mediaInfo;
			return Boolean(mediaInfo && mediaInfo.width && mediaInfo.height);
		},
		getBytes() {
			if(this.stream.totalBytes && this.stream.totalBytes > 0){
		   let totalBytes =  this.stream.totalBytes;
		   var i = Math.floor(Math.log(totalBytes) / Math.log(1000)),
			sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			return (totalBytes / Math.pow(1000, i)).toFixed(2) * 1 + ' ' + sizes[i];
			}else{
				return 0;
			}
		},
		showFileSize() {
			if(this.stream.bytes && this.stream.bytes > 0){
		   let fileSize =  this.stream.bytes;
		   var i = Math.floor(Math.log(fileSize) / Math.log(1000)),
			sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			return (fileSize / Math.pow(1000, i)).toFixed(2) * 1 + ' ' + sizes[i];
			}else{
				return 0;
			}
		}
	},
	mounted() {
		if (this.stream.type !== 'vod') {
			this.subscribeMediaPulse();
		}
	},
	unmounted() {
		this.scopeAlive = false;
		this.unsubscribeMediaPulse();
	},
	methods: {
		shortString,
		date,
		numberFormat,
		onClickButton(event) {
      this.$emit('chosenFolder', this.stream._id)
    },
		async showInnerFiles() {
			let streamId = this.stream._id;
			this.$emit('chosenFolder', streamId);
				try {
				const result = await StreamService.getStreamPlaylist(streamId);
				setTimeout(() => {
					this.VODList = result;
					this.loading = false;
				}, 100);
			} catch (err) {
				this.$notify({ group: "error", title: err.error, text: err.message });
				this.loading = false;
				return;
			}
		},
		subscribeMediaPulse() {
			const streamKey = this.stream.key;
			const self = this;
			(async function loop() {
				if (!self.scopeAlive) return;

				let timeoutInterval = 5000;
				let shouldUpdatePulse = self.stream.enabled;
				if (shouldUpdatePulse && document.hidden) {
					shouldUpdatePulse = false;
					timeoutInterval = 6000;
				}

				if (shouldUpdatePulse) {
					if (!document.hasFocus()) {
						timeoutInterval = 14000;
					}
				}

				if (shouldUpdatePulse) {
					try {
						const pulseObject = await StreamStatsService.getStreamMediaPulse(
							streamKey
						);
						self.onMediaPulse(pulseObject);
					} catch (e) {}
				}

				// reschedule
				self.mediaPulseTimeoutCtrl = setTimeout(
					loop.bind(this),
					timeoutInterval
				);
			}());
		},
		onMediaPulse(pulse = {}) {
			this.mediaPulse = pulse;
			this.$emit('pulse-update', this.stream._id, pulse);
		},
		unsubscribeMediaPulse() {
			clearTimeout(this.mediaPulseTimeoutCtrl);
		},
	}
};
</script>
	
<style scoped>
	img {
		width: auto;
		height: auto;
	}
	.vod-item {
		width: 100%;
		background-color: #1E2745;
	}
	.vod-item:empty{
		display: none;
	}
	.vod-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		min-height: 60px;
	}
	.vod-item__icon {
		height: 21px;
		width: 32px;
		flex: 0 0 32px;
	}
	.vod-item__title {
		font-size: 16px;
		font-weight: 400;
		margin: 0;
		flex: 0 0 calc(40% - 32px);
	}
	.vod-item__info {
		margin: 0;
		flex: 0 0 calc(40% - 32px);
		display: flex;
		flex-wrap:  wrap;
	}
	.vod-item__title_files {
		flex: 0 0 100%;
	}
	.vod-item__files {
		flex: 0 0 20%;
		text-align: right;
	}
	.vod-item__size {
		font-size: 16px;
		flex: 0 0 20%;
		text-align: right;
	}
	.vod-item__date {
		font-size: 16px;
		flex: 0 0 20%;
		text-align: right;
	}
	.vod-item__presets {
		display: flex;
		flex: 0 0 20%;
	}
	.vod-item__preset-item {
		font-size: 12px;
		padding: 8px;
		background-color: #373F5E;
		border: none;
		border-radius: 6px;
		margin: 0 2px;
	}
	.vod-item__res {
		font-size: 14px;
		color: #FAFAFB;
	}
</style>
